import { SDKVoiceFacade, VoiceInfo } from 'modules/sdk/lib';
import { setVoice } from 'modules/voices/stores/actions/setVoice';
import { LOCAL_ENGINE, getVoiceByIDQualified } from 'modules/voices/utils/utils';

import { SharedUserSettingsEnum, useSettingsStore } from './store';

export const getIDQualified = (voice: Pick<VoiceInfo, 'engine' | 'displayName' | 'languageCodeWithLocale' | 'name'>) => {
  switch (voice.engine) {
    case LOCAL_ENGINE:
      return voice.name;

    default:
      return `${voice.engine?.toLowerCase()}-${voice.displayName.toLowerCase()}-${voice.languageCodeWithLocale.toLowerCase()}`;
  }
};

export const waitForSettingSyncToLoad = (): Promise<void> => {
  if (useSettingsStore.getState().syncStatus.lastFetchTimestamp) return Promise.resolve();
  return new Promise(resolve => {
    const unsubscribe = useSettingsStore.subscribe(state => {
      if (state.syncStatus.lastFetchTimestamp) return;
      unsubscribe();
      resolve();
    });
  });
};

export const setVoiceFromSettingSync = () => {
  const state = useSettingsStore.getState();
  if (!state.syncStatus.lastFetchTimestamp) return;

  const allVoices = SDKVoiceFacade.singleton.getAllVoiceInfos();

  const currentVoice = state.userSettings.settings[SharedUserSettingsEnum.CURRENT_VOICE] as string | undefined;
  const webAppVoice = state.userSettings.settings[SharedUserSettingsEnum.WEB_CURRENT_VOICE] as string | undefined;

  let voice = currentVoice ? getVoiceByIDQualified(currentVoice, allVoices) : undefined;

  if (!voice && webAppVoice) {
    voice = getVoiceByIDQualified(webAppVoice, allVoices);
  }

  voice && setVoice(voice, { shouldPlayPreview: false, isChangeFromSettingSync: true });
};
